export default {
    invite: "/invite/:id",
    login: "/login",
    inviteList: "/list"
}